import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    if (excelFileName.length > 30) {
      excelFileName = excelFileName.substr(0, 15) + '_';
    }

    const ws = XLSX.utils.json_to_sheet(json);

    /* add to workbook */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, excelFileName);
    const seqNum = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
    const fileName = excelFileName.toLowerCase() + seqNum + EXCEL_EXTENSION;
    /* write workbook and force a download */
    XLSX.writeFile(wb, fileName);
  }

  public exportAsExcelNew(json: any[], excelFileName: string): void {

    if (excelFileName.length > 30) {
      excelFileName = excelFileName.substr(0, 30);
    }

    const ws = XLSX.utils.json_to_sheet(json);

    /* add to workbook */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, excelFileName);
    const fileName = excelFileName.toLowerCase() + EXCEL_EXTENSION;
    /* write workbook and force a download */
    XLSX.writeFile(wb, fileName);
  }

}
